import { makeStyles } from "@material-ui/core/styles";

// D8.14.1 — Estilos de NodeConfigModal.
export const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5, 1),
    },
  },
  tabPanel: {
    padding: theme.spacing(2, 0),
  },
  // ── Contenedor scrollable de ítems (content node) ──────────────────────────
  contentItemsScroller: {
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: "40vh",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    "&::-webkit-scrollbar": {
      width: 4,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.type === "dark" ? "#555" : "#c8c8c8",
      borderRadius: 4,
    },
    [theme.breakpoints.down("xs")]: {
      maxHeight: "35vh",
    },
  },
  // ── Previews multimedia ────────────────────────────────────────────────────
  previewImageBox: {
    borderRadius: 6,
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.type === "dark" ? "#1a1a1a" : "#f0f0f0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    maxHeight: 150,
  },
  previewImage: {
    width: "100%",
    maxHeight: 150,
    objectFit: "cover",
    display: "block",
  },
  previewVideo: {
    width: "100%",
    maxHeight: 140,
    borderRadius: 6,
    display: "block",
    marginBottom: theme.spacing(1),
    backgroundColor: "#000",
  },
  previewAudio: {
    width: "100%",
    height: 40,
    display: "block",
    marginBottom: theme.spacing(1),
  },
  previewDocument: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "#f5f5f5",
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(1),
  },
}));
